module.exports = {"TXTWCL_Accept_Price_Changes":{"id":"TXTWCL_Accept_Price_Changes","defaultMessage":"Acceptér ændrede odds","track":"Accept Price Changes"}}